module.exports = __webpack_public_path__ + "static/img/b_1_cross.88c134fd.png";